export const UNIT_TYPE_EVENTS_SHOW = "UNIT_TYPE_EVENTS_SHOW";
export const UNIT_TYPE_EVENTS_SHOW_RESULT = "UNIT_TYPE_EVENTS_SHOW_RESULT";
export const UNIT_TYPE_EVENTS_SHOW_HIDE = "UNIT_TYPE_EVENTS_SHOW_HIDE";